import React from "react";
import { QueryBoundary } from "shared/api/QueryBoundary";
import { GenericErrorPage } from "shared/components/empty/GenericErrorPage";
import { LoggedInHeaderNav } from "shared/components/layout/LoggedInHeaderNav";
import PageNav from "shared/components/layout/PageNav";
import Logo from "shared/img/logo.svg?react";

export const LoggedInLayout: React.FC<
  React.PropsWithChildren & { isInternalAdminDashboardView?: boolean }
> = ({ children, isInternalAdminDashboardView }) => (
  <>
    <PageNav isInternalAdminDashboardView={isInternalAdminDashboardView}>
      <LoggedInHeaderNav
        isInternalAdminDashboardView={isInternalAdminDashboardView}
      />
    </PageNav>
    <QueryBoundary isPage={true} ErrorComponent={LoggedInLayoutError}>
      {children}
    </QueryBoundary>
  </>
);

const LoggedInLayoutError: React.FC = (props) => (
  <>
    <PageNav>
      <Logo />
    </PageNav>
    <GenericErrorPage {...props} showSignOut={true} />
  </>
);
